<template>
  <div class="dropdown" @mouseleave="hideDropdown">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <button class="dropbtn" @click="mostrarContenido()" >
                <span v-if="cambioTag !== null">
                                {{cambioTag.descripcionTagMotivoCita}}
                  <em v-if="mostrarTagCita" class="arrow_down_svg chevron-verde ml-2" style="width: 13px; transform: rotate(180deg);"></em>
                  <em v-else class="arrow_down_svg chevron-verde ml-2" style="width: 13px; transform: rotate(360deg);"></em>
                  </span>
    </button>
    <div v-if="mostrarTagCita" class="dropdown-content">
      <p class="m-2" style="border-bottom: 1px solid #e9e9e9 !important;"><strong>Motivo de cita</strong></p>
      <div style="  min-width: 15vw; max-height: 30vh; overflow-y: auto;">
                  <span v-for="(t,i) in tagmotivocitaDatosArrayOriginal" :key="i">
                      <a @click="obtenerTagSeleccionado(t)">{{t.descripcionTagMotivoCita}}</a>
                   </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModificarTagMotivoCita",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      mostrarTagCita: false,
      listaMotivoCita: [],
    }
  },
  props: {
    idSesion: Number,
    idDenticion: Number,
    cambioTag: Object,
    tagmotivocitaDatosArrayOriginal:Array,
  },
  watch: {
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods:{
    hideDropdown() {
      this.mostrarTagCita = false;
    },
    mostrarContenido(){
      this.mostrarTagCita = !this.mostrarTagCita;
    },
    obtenerTagSeleccionado(tagSelecionado){
      this.$emit('TagMotivoSeleccionado', tagSelecionado);
      this.mostrarTagCita = false;
    }
  }
}
</script>

<style scoped>
.chevron-verde {
  filter: brightness(0) saturate(100%) invert(70%) sepia(4%) saturate(6367%) hue-rotate(60deg) brightness(91%) contrast(100%);
}

/* Estilo para el botón */
.dropbtn {
  background-color: white;
  padding: 16px;
  border: none;
  cursor: pointer;
  color: #65c045;
  font-size: 0.95em;
  font-weight: bold;

}

/* Estilo para el contenedor del botón */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Estilo para el contenido desplegable (oculto por defecto) */
.dropdown-content {
  position: absolute;
  background-color: #f9f9f9;
  min-width: 13vw;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  display: block;
  border-radius: 10px;

}

/* Estilo para los enlaces dentro del contenido desplegable */
.dropdown-content a {
  color: black;
  padding: 10px 10px;
  text-decoration: none;
  display: block;
  border-bottom: 1px solid #e9e9e9 !important;
  font-size: small;
}

/* Cambiar el color de los enlaces al pasar el mouse */
.dropdown-content a:hover {background-color: #f1f1f1}


/* Cambiar el color de fondo del botón cuando se muestra el contenido desplegable */
.dropdown:hover .dropbtn {
  background-color: #e9e9e9;
}
.dropdown:focus .dropbtn {
  border: none;
}
</style>
